module.exports = __webpack_public_path__ + "img/youtube.ce92cb5d.svg";